import { Avatar, AvatarFallback, AvatarImage } from "@/components/molecules/Avatar"
import React from "react"

interface UserInfoProps {
  name: string
  roles: string
  imageUrl: string
  orientation?: string
}

const UserInfo: React.FC<UserInfoProps> = ({ name, roles, imageUrl, orientation = "horizontal" }) => (
  <div className={`flex place-content-start space-x-4 ${orientation === "vertical"} && "flex-col`}>
    <Avatar>
      <AvatarImage src={imageUrl} alt={name} />
      <AvatarFallback>{name ? name.charAt(0).toUpperCase() : "U"}</AvatarFallback>
    </Avatar>
    <div>
      <h3 className="font-semibold capitalize">{name}</h3>
      <p className="text-sm text-gray-500">{roles}</p>
    </div>
  </div>
)

export default UserInfo
